import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { setTitle } from 'modules/common/utils';
import CommonBreadcrumbItem from './CommonBreadCrumbItem';
import { colors, dimensions } from '../../styles';
import { withRouter } from 'react-router';

const Items = styled.ol`
  display: inline-block;
  // padding: 12px 8px;
  // margin: 0 -20px 0 0;
  list-style: none;
  font-size: 14px;
  text-align: center;
  // background: ${colors.colorWhite};
  
  @media (max-width: 760px)
  {
    display: flex;
    justify-content: space-evenly;
    background-color: white;
    border-radius: 10px;
    padding: 8px 5px;
    overflow: scroll;

    &::-webkit-scrollbar { 
      display: none;  /* Safari and Chrome */
    }
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
  }
`;

const propTypes = {
  breadcrumbs: PropTypes.array.isRequired
};

class CommonBreadCrumb extends Component {

  constructor(props) {
    super(props);
  }

  setTabTitle() {
    const { __ } = this.context;
    const { breadcrumbs } = this.props;
    const page = breadcrumbs.pop();

    setTitle(
      page.title,
    page.title === `${__('Inbox')}` && document.title.startsWith('(1)')
    );
  }

  componentDidUpdate() {
    this.setTabTitle();
  }

  componentDidMount() {
    this.setTabTitle();
  }

  render() {
    const pathname = this.props.history.location.pathname;
    console.log(pathname);

    return (
      <Items role="navigation" aria-label="breadcrumbs">
      {window.innerWidth <= 768 ?  

          this.props.breadcrumbs.map(b => (
            <CommonBreadcrumbItem to={b.link} active={pathname === b.link ? true : false} key={b.title}>
              <img src={b.icon} width={35} height={35} />
            </CommonBreadcrumbItem>
          ))
        : this.props.breadcrumbs.map(b => (
          <CommonBreadcrumbItem to={b.link} active={pathname === b.link ? true : false} key={b.title}>
            <img src={b.icon} width={35} height={35} /> {b.title}
          </CommonBreadcrumbItem>
      ))}
      </Items>
    );
  }
}

CommonBreadCrumb.propTypes = propTypes;
CommonBreadCrumb.contextTypes = {
  __: PropTypes.func
};

export default withRouter(CommonBreadCrumb);



// WEBPACK FOOTER //
// ./src/modules/common/components/commonPageHeader/CommonBreadCrumb.js